export function saltarBeneficiarios(observations) {
  return observations && false;
}

export function saltarDependientes(observations) {
  return (
    observations &&
    (observations.includes("GT01") ||
      observations.includes("GT04") ||
      observations.includes("GT05"))
  );
}

export function bankNotRequired(observations) {
  return (
    observations &&
    (observations.includes("GT01") ||
      observations.includes("GT04") ||
      observations.includes("GT05"))
  );
}

export function planType(observations) {
  if (observations.includes("GT01")) {
    return ["V"];
  }
  if (observations.includes("GT02")) {
    return ["V", "G"];
  }
  if (observations.includes("GT03")) {
    return ["V", "G", "D"];
  }
  if (observations.includes("GT04")) {
    return ["V", "A"];
  }
  if (observations.includes("GT05")) {
    return ["A"];
  }

  return [];
}
